import {
    Card,
    CardContent,
    Divider,
    Grid,
    TextField,
    Container,
    Dialog,
    DialogTitle,
    IconButton
} from '@mui/material'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Close } from '@mui/icons-material'
import { ActionButton } from '../../../utils/ui_utils'

function UserProfileDrawer({
    visible,
    okText,
    onSubmit,
    onClose,
    initialValues,
    title
}) {
    if (initialValues == undefined)
        initialValues = {
            account_status: "",
            address: "",
            email: "",
            first_name: "",
            last_name: "",
            mobile: "",
            user_name: "",
            user_type: ""
        }

    const handleSubmit = async (values, { resetForm, setErrors, setStatus, setSubmitting }) => {
        onSubmit(values)
    }

    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required('Required').min(2, 'Min length is 2 character'),
        last_name: Yup.string(),
        password: Yup.string().min(6, 'Must be at least 6 characters').max(255),
        confirmPassword: Yup.string().when('password', {
            is: (val) => !!(val && val.length > 0),
            then: Yup.string()
                .required('Required')
                .oneOf([Yup.ref('password')], 'Passwords do not match'),
        }),
    })

    return (
        <>
            <Dialog
                maxWidth='xs'
                fullWidth
                open={visible}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle sx={{ "display": "flex", "justifyContent": "space-between", alignItems: "center" }}>
                    {title}
                    <IconButton
                        component="span"
                        size='small'
                        sx={{ ':hover': { backgroundColor: "red", color: "white" } }}
                        onClick={onClose}
                        variant="contained"
                    >
                        <Close />
                    </IconButton>
                </DialogTitle>
                <Container sx={{ marginBottom: 5 }} >
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validationSchema}
                        onSubmit={handleSubmit}
                    >
                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values,
                            status,
                        }) => (
                            <form onSubmit={handleSubmit}>
                                <Divider my={2} />
                                <Card>
                                    <CardContent>
                                        <Grid container spacing={6}>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="first_name"
                                                    label="First Name"
                                                    value={values.first_name}
                                                    error={Boolean(touched.first_name && errors.first_name)}
                                                    fullWidth
                                                    helperText={touched.first_name && errors.first_name}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                            <Grid item md={6}>
                                                <TextField
                                                    size="small"
                                                    name="last_name"
                                                    label="Last Name"
                                                    value={values.last_name}
                                                    error={Boolean(touched.last_name && errors.last_name)}
                                                    fullWidth
                                                    helperText={touched.last_name && errors.last_name}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>

                                        <Grid container spacing={6}>
                                            <Grid item md={12}>
                                                <TextField
                                                    size="small"
                                                    name="address"
                                                    label="Address"
                                                    value={values.address}
                                                    error={Boolean(touched.address && errors.address)}
                                                    fullWidth
                                                    helperText={touched.address && errors.address}
                                                    onBlur={handleBlur}
                                                    margin="dense"
                                                    onChange={handleChange}
                                                    variant="outlined"
                                                    multiline
                                                    my={2}
                                                />
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                                <Grid container justifyContent="flex-end">
                                    <Grid item >
                                        <ActionButton variant="outlined" size='medium' type="submit" mt={8}>
                                            {okText}
                                        </ActionButton>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    </Formik>

                </Container>
            </Dialog>
        </>
    )
}

export default UserProfileDrawer;